<template>
  <div
    class="login"
    :class="[isWide && 'login--wide']"
  >
    <div
      class="login__logo"
    >
      <v-logo />
    </div>
    <div class="login__wrap">
      <div class="login__form">
        <v-headline
          v-if="title"
          :level="1"
          is-centered
        >
          {{ title }}
        </v-headline>
        <div class="login__inner">
          <v-alert
            v-if="errors"
            color="error"
            icon="notification"
          >
            {{ errors }}
          </v-alert>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Headline from "@/atoms/Headline";
  import Logo from "@/atoms/Logo";
  import Alert from "@/atoms/Alert";

  import {mapState} from "vuex";

  export default {
    components: {
      "v-headline": Headline,
      "v-logo": Logo,
      'v-alert': Alert,
    },
    props: {
      title: {
        type: String,
        default: null
      },
      isWide: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...mapState({
        errors: state => state.auth.errors
      })
    },
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .login {
    $this: &;
    position: relative;
    display: flex;
    min-height: 100%;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    background-color: $white;
    overflow: hidden;
    @include minpoint(tablet) {
      background: $white;
      flex-direction: row;
      &::after {
        display: block;
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: 0;
        box-shadow: -5px 1px 10px 0 rgba(9, 33, 57, 0.32);
        background: linear-gradient(154.81deg, #0546c7 0%, #001744 100%);
        left: 60%;
        right: 0;
      }
    }
    &__logo {
      max-width: 100%;
      text-align: center;
      padding: 15px 30px;
      margin: 0 auto;
      .logo {
        svg {
          max-width: 100%;
          width: 600px;
          @include minpoint(tablet) {
            width: 600px;
          }
        }
      }
      @include minpoint(tablet) {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        &:before {
          @include pseudoBlock;
          width: 100vw;
          height: 100vw;
          position: absolute;
          z-index: 0;
          border: 100px solid var(--accent);
          --accent: $tangerine;
          transform-origin: top left;
          transform: rotate(50deg);
          top: 66%;
          left: 66%;
        }
      }
    }
    &__wrap {
      padding-left: 15px;
      padding-right: 15px;
      flex: 1;
      @include maxpoint(phone) {
        background: linear-gradient(to bottom, $white 60px, #001a4d 60px);
        padding-bottom: 100px;
        padding-top: 10px;
      }
      @include minpoint(tablet) {
        z-index: 1;
        display: flex;
        flex: 1;
        align-items: center;
        position: relative;
        transform-style: preserve-3d;
        justify-content: flex-start;
      }
    }
    &__form {
      position: relative;
      width: 100%;
      border-radius: 4px;
      background: $white;
      box-shadow: 0 0 9px 0 rgba(132, 142, 176, 0.4);
      padding: 30px 15px;
      transform-style: preserve-3d;
      form {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-bottom: 0;
      }
      @include minpoint(tablet) {
        display: flex;
        flex-direction: column;
        padding: 45px;
        margin-left: 10px;
        margin-right: 0;
        max-width: 500px;
        min-height: 48vh;
        max-height: 90vh;

        &:before {
          --accent: #fb8c33;
          border-width: 200px;
          transform-origin: bottom left;
          transform: translate(-10%, 5%) rotate(50deg) translateZ(-1em);
          bottom: 100%;
          left: 100%;
        }
      }
      &:before,
      &:after {
        width: 100vw;
        height: 100vw;
        @include pseudoBlock;
        position: absolute;
        z-index: -1;
        border: 50px solid var(--accent);
        @include minpoint(tablet) {
          width: 50vw;
          height: 50vw;
          border-width: 100px;
        }
      }
      &:after {
        transform-origin: top left;
        transform: translate(0%, -10%) rotate(50deg);
        top: 100%;
        left: 100%;
        --accent: #133373;
        @include minpoint(tablet) {
          --accent: #01386f;
        }
      }
    }
    &__inner {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
    }
    &--wide {
      #{$this}__logo {
        flex: 2;
      }
      #{$this}__wrap {
        flex: 5;
      }
      #{$this}__form {
        @include minpoint(tablet) {
          max-width: 600px;
          min-height: 70vh;
        }
        @include minpoint(desktop) {
          max-width: 800px;
        }
      }
    }
  }


</style>
